import client from "services/ngage/api-client";
import DataPage from "types/DataPage";
import {Document, DocumentData} from "types/Document";
import deserializeDocument from "services/ngage/deserializers/document";

/**
 * Get all documents (paginated)
 */
const all = async (page: number = 1) => {
    const response = await client.get<DataPage<Document> | null>(`/documents?page=${page}`)

    if(response.data){
        response.data.data = response.data.data.map(deserializeDocument)
    }

    return response.data
}

/**
 * Get a single document
 *
 * @param {number} id
 */
const get = async (id: number) => {
    const response = await client.get<Document | null>(`/documents/${id}`)
    return response.data? deserializeDocument(response.data) : null
}

/**
 * Get the download URL for a document asset
 *
 * @param id
 * @param subdomain
 */
const downloadUrl = (id: number, subdomain?: string | null) => {
    const operatorParameter = subdomain? `?operator=${subdomain}` : '';
    return `${client.defaults.baseURL}/documents/${id}/asset${operatorParameter}`
}

/**
 * Store a new document
 *
 * @param data
 */
const store = async (data: DocumentData) => {
    const response = await client.post<Document | null>('/documents', data)
    return response.data? deserializeDocument(response.data) : null
}

/**
 * Update an existing document
 *
 * @param {number} id
 * @param data
 */
const update = async (id: number, data: DocumentData) => {
    const response = await client.put<Document | null>(`/documents/${id}`, data)
    return response.data? deserializeDocument(response.data) : null
}

/**
 * Permanently delete a document
 *
 * @param {number} id
 */
const destroy = async (id: number) => {
    const response = await client.delete<null>(`/documents/${id}`)
    return response.status === 204
}

const documents = {
    all,
    get,
    downloadUrl,
    store,
    update,
    destroy
}

export default documents;